<template>
  <div>
    <VForm ref="formRef" @submit.prevent="uploadCert">
      <VCard class="pa-3 mb-3">
        <div class="text-subtitle-2">經費需求項目名稱-經費預算申請單號<Required/></div>
          <v-autocomplete
            prepend-inner-icon="tabler-search"
            :loading="loadingUpload"
            v-model="form.applyNo"
            :items="activityNames"
            :rules="[rules.required]"
            item-title="projectTitle"
            item-value="applyNo"
            id="經費需求項目名稱-經費預算申請單號"
            no-data-text="尚無可核銷單據"
            @update:modelValue="changeApplyNo"
            class="w-90"
            inputmode="text" 
          ></v-autocomplete>
      </VCard>
      <v-expansion-panels eager v-model="panel" elevation="0" flat class="mt-2">
        <v-expansion-panel title="新增憑證資料" eager>
          <v-expansion-panel-text>
            <div>
              <div class="text-subtitle-2">行程</div>
                <v-select
                  :loading="loadingUpload"
                  v-model="form.uploadData.scheduleId"
                  :items="form.scheduleIdnItemList.scheduleList"
                  item-title="scheduleName"
                  item-value="scheduleNo"
                  id="新增行程"
                  no-data-text="尚無可核銷單據"
                  :disabled="!form.applyNo"
                  clearable
                  @click:clear="form.uploadData.itemId = ''"
                  :hint="form.applyNo?'':'請先選擇申請單'"
                  :persistent-hint="form.uploadData.applyNo?false:true"
                  inputmode="none" 
                ></v-select>
            </div>
            <div class="mt-1">
              <div class="text-subtitle-2">檔案<Required/></div>
                <div v-if="typeof form.uploadData.certFilesId=='string'&&form.uploadData.certFilesId&&form.uploadData.certFiles.length<6" class="d-flex justify-space-between">
                  <div class="d-flex align-center">
                    <v-icon icon="tabler-paperclip"></v-icon>
                      <div class="d-flex flex-column">
                        <a class="ml-2" target="_blank"  v-for="file in certFilesToArray(form.uploadData.certFilesId)" :key="file" @click.prevent="getJwtBeforeRedirect(file)" href="">{{file}}</a>
                      </div>
                  </div>
                  <v-btn class="bg-white align-self-center" color="black" variants="text" icon="tabler-x" @click="clearFile"></v-btn>
                </div>
                <VFileInput accept="image/*,.jpg,.pdf,.png,.heic" v-else id="檔案" :loading="loadingUpload" counter show-size multiple v-model="form.uploadData.certFiles" :rules="[rules.required,rules.fileLimitLength]"  @change="handleOfficalFileMultiple('certFiles','certFilesId')" @click:clear="clearFile"/>
            </div>
            <v-card
              v-if="slides.length"
              variant="outlined"
            >
              <v-window v-model="onboarding">
                <v-window-item
                  v-for="(slide, index) in slides"
                  :key="slide.name"
                  :value="index"
                >
                  <v-card
                    class="d-flex justify-center align-center"
                  >
                    <div v-if="slide.type === 'image'" style="text-align: center; width: 100%;">
                      <img
                        max-height="600px"
                        :src="slide.url"
                        :alt="slide.name"
                        style="max-height: 100%; max-width: 100%; object-fit: contain;"
                      />
                    </div>
                    <div v-else class="d-flex flex-column align-center justify-center">
                      <v-btn variant="text"  size="large" @click="getJwtBeforeRedirect(certFilesToArray(form.uploadData.certFilesId)[onboarding])">
                        <v-icon size="large">tabler-file</v-icon>
                        下載檔案
                      </v-btn>
                      <!-- <span>{{ slide.name }}</span> -->
                      <!-- <small>({{ (slide.size / 1024).toFixed(1) }} KB)</small> -->
                    </div>
                  </v-card>
                </v-window-item>
              </v-window>
              <div class="text-center">{{certFilesToArray(form.uploadData.certFilesId)[onboarding]}} - {{slides[onboarding]?.name}}</div>
              <v-divider></v-divider>
              <v-card-actions class="justify-space-between mx-0 px-0">
                <v-btn
                  icon="tabler-chevron-left"
                  variant="plain"
                  @click="prev"
                  color="primary"
                  :disabled="onboarding==0" 
                ></v-btn>
                <v-item-group
                  v-model="onboarding"
                  class="text-center"
                  mandatory
                >
                  <v-item
                    v-for="(slide, index) in slides"
                    :key="`btn-${index}`"
                    v-slot="{ isSelected, toggle }"
                    :value="index"
                  >
                    <v-btn
                      :variant="isSelected ? 'outlined' : 'text'"
                      icon="mdi-record"
                      @click="toggle"
                      size="x-small"
                    >{{index+1}}</v-btn>
                  </v-item>
                </v-item-group>
                <v-btn
                  icon="tabler-chevron-right"
                  variant="plain"
                  color="primary"
                  @click="next"
                  :disabled="onboarding+1>=length"  
                ></v-btn>
              </v-card-actions>
            </v-card>
            
            <div class="mt-1">
              <div class="text-subtitle-2">項目</div>
                <v-select
                  v-model="form.uploadData.itemId"
                  :items="
                  (form.scheduleIdnItemList?.scheduleItem && form.uploadData.scheduleId && form.scheduleIdnItemList.scheduleItem[form.uploadData.scheduleId]) ? form.scheduleIdnItemList.scheduleItem[form.uploadData.scheduleId].itemList : []"
                  item-title="itemName"
                  item-value="itemType"
                  id="新增項目"
                  :disabled="!form.applyNo||!form.uploadData.scheduleId"
                  :loading="loadingUpload"
                  clearable
                  :hint="form.uploadData.scheduleId?'':'有行程才能選項目'"
                  :persistent-hint="form.uploadData.scheduleId?false:true"
                  inputmode="none" 
                  no-data-text="尚無項目資料"
                ></v-select>
            </div>
            <div class="d-flex justify-end mt-3">
              <v-btn color="warning" variant="tonal" class="align-self-end mx-3 mb-3" :loading="loadingUpload" type="submit">
                <v-icon>tabler-device-tablet-up</v-icon>
                上傳憑證
              </v-btn>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </VForm>

    <VCard class="mt-3">
      <VDataTableServer
        loading-text="...Loading..."
        :loading="loading"
        v-model:items-per-page="filter.size"
        v-model:page="filter.currentPage"
        :items="form.reimbursementItemList || []"
        :items-length="totalDatas"
        :headers="grid1Headers"
        class="text-no-wrap"
        no-data-text="尚無憑證資料"
      >
        <!-- :hide-default-header="smAndDown" -->
        <template v-slot:headers v-if="smAndDown">
        </template>
        <template #item.scheduleId="{ item, index }" v-if="!smAndDown">
          <span :class="{ 'text-primary font-weight-bold': matchAddList(item),}">
            {{getScheduleName(item.scheduleId)}}
          </span>
        </template>
        <template #item.certFiles="{ item, index }" v-if="!smAndDown">
          <div class="d-flex flex-column">
            <a v-for="file in certFilesToArray(item.certFiles)" :key="file" target="_blank" 
            :class="{ 'text-primary font-weight-bold': matchAddList(item),}"  
            @click.prevent="getJwtBeforeRedirect(file)" href="">
              {{file}}
            </a>
          </div>
        </template>
        <template #item.itemId="{ item, index }" v-if="!smAndDown">
          <span :class="{ 'text-primary font-weight-bold': matchAddList(item),}">
            {{getReimbursementItemName(item.itemId)}}
          </span>
        </template>
        <template #item.delete="{ item, index }" v-if="!smAndDown">
          <v-btn color="error" variant="tonal" class="align-self-end" :loading="loading" icon @click="deleteCertiItem(item)">
            <v-icon>tabler-trash</v-icon>
          </v-btn>
          <v-btn color="warning" variant="tonal" class="align-self-end ml-2" :loading="loading" icon @click="openDialog(item)">
            <v-icon>tabler-photo</v-icon>
          </v-btn>
        </template>
        <template v-slot:item="{ item }" v-if="smAndDown">
          <!-- 手機版 -->
          <VRow class="ma-0 pa-0">
            <VCol cols="12" md="6" class="py-2 d-flex justify-space-between">
              <div class="text-subtitle-2">行程</div>
              <div :class="{ 'text-primary font-weight-bold': matchAddList(item),}" >
                {{getScheduleName(item.scheduleId)}}
              </div>
            </VCol>
            <VCol cols="12" md="6" :class="['py-2', 'd-flex', 'justify-space-between']">
              <div class="text-subtitle-2">檔案</div>
              <div :class="{ 'text-primary font-weight-bold': matchAddList(item), 'd-flex flex-column': certFilesToArray(item.certFiles).length>1 }">
                <a  v-for="file in certFilesToArray(item.certFiles)" :key="file" target="_blank" 
                :class="{ 'text-primary font-weight-bold': matchAddList(item),}"  
                @click.prevent="getJwtBeforeRedirect(file)" href="">
                  {{file}}
                </a>
              </div>
            </VCol>
            
            <VCol cols="12" md="6" class="py-2 d-flex">
              <v-row class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0 d-flex justify-end ga-4">
                  <v-btn color="error" variant="tonal" class="align-self-end " :loading="loading" icon @click="deleteCertiItem(item)">
                    <v-icon>tabler-trash</v-icon>
                  </v-btn>
                  <v-btn color="warning" variant="tonal" class="align-self-end" :loading="loading" icon @click="openDialog(item)">
                    <v-icon>tabler-photo</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="10" class="pa-0 ma-0 text-right">
                  <div class="text-right">
                    <div class="d-flex justify-end">
                      <VSkeletonLoader :loading="loading" type="chip" class="text-right">
                        <v-chip :color=" matchAddList(item)?'primary':'secondaty'" variant="tonal" v-if="item.itemId" class="text-right">
                          {{getReimbursementItemName(item.itemId)}}
                        </v-chip>
                      </VSkeletonLoader>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </VCol>
            <VCol cols="12" md="6" class="py-2 d-flex">
              <v-divider class="my-3"></v-divider>
            </VCol>
          </VRow>
        </template>
        <template #bottom>
          <TablePagination
            v-model:page="filter.currentPage"
            v-model:size="filter.size"
            :items-per-page="filter.size"
            :total-items="totalDatas"
          />
        </template>
      </VDataTableServer>
    </VCard>
    <VDialog
      :model-value="isDialogVisible"
      width="100%"  
      height="100%"
      @update:model-value="isDialogVisible = false"
    >
      <DialogCloseBtn
        size="small"
        @click="isDialogVisible = false"
      />
      <VCard>
        <VCardTitle v-if="!dialogData.contentType.includes('webp')" class="text-center">
          <v-icon :icon="dialogDataIcon" color="primary"></v-icon>
          <v-btn v-if="dialogDataIcon!=='tabler-photo'" variant="text" color="primary" @click.prevent="getJwtBeforeRedirect(dialogData.certFiles.replace('.webp',''))">下載檔案</v-btn>
          <div class="text-center">{{dialogData.certFiles.replace('.webp','')}}</div>
        </VCardTitle>
        <VCardText v-if="dialogData.photo" class="w-100 h-100">
          <v-img
            v-if="dialogData.photo"
            rounded="sm"
            :src="dialogData.photo"
            contain
          ></v-img>
        </VCardText>
      </VCard>
    </VDialog>
    <v-snackbar v-model="snackbar.show" :timer="snackbar.timer" :timeout="snackbar.timeout" :color="snackbar.color" :text="snackbar.text" :location="snackbar.location">
    </v-snackbar>
  </div>
</template>
<script setup lang="ts">
import { ref, computed, reactive, watch } from 'vue'
import type { VForm } from 'vuetify/components'
import { useDisplay } from 'vuetify/lib/framework.mjs'
import Required from '../../../components/required.vue'
definePage({
  meta: {
    action: 'manage',
    subject: 'PAYMENTVOUCHERUPLOAD',
  },
})

const snackbar = ref({
  show:false,
  text:'',
  color:'primary',
  timeout:1500,
  location:'top center',
  timer:true,
})
const { smAndDown } = useDisplay()

// 控制擴展面板預設是否開啟
const panel = ref([0]);

const isDialogVisible = ref(false)
const dialogData = ref({
  certFiles:'',
  photo:'',
  contentType:'',
})
const fileUrl = useStorage("drFsUrl").value;
const loading = ref(false)
const loadingUpload = ref(false)
const addList = ref([])
const filter = ref({
  currentPage:1,
  size:10,
})
const currentPage = ref(1)
const totalDatas = ref(0)

const isGold = computed(() => {
  if (!form.applyNo || !activityNames.value) return false
  const selected = activityNames.value.find(item => item.applyNo === form.applyNo)
  return selected?.isGold === 'Y'
})

const length = computed(()=>slides.value.length)
const onboarding = ref(0)

const next = () => {
  onboarding.value = onboarding.value + 1 >= length.value ? length.value-1 :onboarding.value + 1 
}
const prev = () => {
  onboarding.value = onboarding.value - 1 <= 0 ? 0 : onboarding.value - 1
}

const dialogDataIcon = computed(()=>{
  if(dialogData.value.contentType.includes('webp')){
    return 'tabler-photo'
  }else if(dialogData.value.contentType.includes('pdf')){
    return 'tabler-file-type-pdf'
  }else if(dialogData.value.contentType.includes('octet-stream')){
    return 'tabler-file-type-doc'
  }else{
    return 'tabler-file-smile'
  }
})

const grid1Headers = ref([
  {
    title: '行程',
    key: 'scheduleId',
  },
  {
    title: '檔案',
    key: 'certFiles',
  },
  {
    title: '項目',
    key: 'itemId',
  },
  {
    title: '刪除',
    key: 'delete',
  },
])

// 表單驗證規則
const rules = ref({
  required: value => {
    if(Array.isArray(value)){
      return value.length>0 ||'此欄位為必填'
    }else if (typeof value === 'object' && value !== null) {
      return !!value || '此欄位為必填';
    }else{
      return (!!value||value===0) || '此欄位為必填'
    }
  },
  fileLimitLength: (value: any) =>{
    if(Array.isArray(value)){
      if(value.length>5){
        return '只允許最多五個檔案'
      }else{
        return value.length>0 && value.length<6 ||'此欄位為必填'
      }
    }
  },
});
const formRef=ref<VForm>()

const { data: projectForReimb, execute: getProjectForReimb } = await useApi<any>(createUrl('/tca/expenserequestlist/getProjectForReimb', {
  query: {},
}))
const activityNames = computed(()=>projectForReimb.value?projectForReimb.value:[])

const initForm ={
  applyNo:'',
  //applyNo行程內容項目-scheduleItem行程為key對應項目 scheduleList行程列表
  scheduleIdnItemList:{},
  uploadData:{
    scheduleId:'',
    itemId:'',
    certFiles:[],
    certFilesId:'',
  },
  reimbursementItemList:[], //上傳核銷
}

const form = reactive(JSON.parse(JSON.stringify(initForm)));

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}
// API---------------------
// 查詢核銷項目_簡易公用表格  Reimbursement
const { data: getReimbursementItems, execute: fetchReimbursementItem } = await useApi<any>(createUrl('/q/de/select/select/select/deSelect', {
  query: {
    tabId: 'Reimbursement',
  },
}))
const reimbursementItems = computed(()=>getReimbursementItems.value)
// 上傳文件-多檔
const uploadFileMultiple =async(files,val)=>{
  loadingUpload.value = true
  try {
    const response = await $api(`/tca/file/uploadFiles`, {
      method: 'POST',
      body: files,
    });
    form.uploadData[val] = response.fileIdList
    loadingUpload.value = false
  } catch (error) {
    loadingUpload.value = false
    popSwal('error',"上傳失敗",error.message || "請稍後再試")
  }
}
;

// 查詢applyNo行程內容項目
const getScheduleItemList =async(applyNo=null) =>{
  try {
    const response = await $api('/tca/expenserequest/scheduleItemListByApplyNo', {
      method: 'POST',
      query:{
        applyNo:applyNo??form.applyNo
      },
    });
    return response.data
  } catch (error) {
    console.log('getScheduleItemList Error during fetch:', error);
  }
}

const updateInvoice = async()=>{
  loadingUpload.value = true
  try {
    const response = await $api('/tca/expenseReimbursement/updateInvoice', {
      method: 'POST',
      body:{
        priKey:'',
        applyNo:form.applyNo,
        scheduleId:form.uploadData.scheduleId,
        itemId:form.uploadData.itemId,
        certFiles:form.uploadData.certFilesId,
      },
    });
    loadingUpload.value = false
    let data = {
      prikey:'',
      scheduleId:'',
      itemId:'',
      certFiles:[],
      certFilesId:'',
    }
    Object.assign(form.uploadData , data)
    clearFile('certFiles')
    await getInvoiceByApplyNo(form.applyNo)
    snackbar.value.show = true
    snackbar.value.text = '新增成功'
    snackbar.value.color = 'success'
    return response.data
  } catch (error) {
    popSwal('error','新增憑證資料錯誤',error)
    console.log('updateInvoice Error during fetch:', error);
  }
}
// get applyNo 憑證
const getInvoiceByApplyNo = async(applyNo)=>{
  loading.value = true
  try {
    const response = await $api('/tca/expenseReimbursement/getInvoiceByApplyNo', {
      method: 'POST',
      query:{
        applyNo:applyNo??form.applyNo,
        page:filter.value.currentPage-1,
        size:filter.value.size,
      },
    });
    loading.value = false
    totalDatas.value = response.data.totalElements
    form.reimbursementItemList.splice(0,form.reimbursementItemList.length, ...response.data.content)
    return response.data
  } catch (error) {
    console.log('getInvoiceByApplyNo Error during fetch:', error);
  }
}

const deleteInvoice = async(prikey)=>{
  try {
    const response = await $api('/tca/expenseReimbursement/deleteInvoice', {
      method: 'POST',
      query: { 
        prikey,
      },
    });
    await getInvoiceByApplyNo(form.applyNo)
    snackbar.value.show = true
    snackbar.value.text = '刪除成功'
    snackbar.value.color = 'success'
    return response.data
  } catch (error) {
    popSwal('error','刪除憑證資料錯誤',error)
    console.log('deleteInvoice Error during fetch:', error);
  }
}

const getPhotoWebp = async (certiFiled: string): Promise<Blob> => {
  if(!certiFiled){
    popSwal('error', "照片FileId取得失敗", "請稍後再試")
    return
  }
   try {
    const response = await fetch(`/tca/file/${certiFiled}`, {
      method: 'GET',
    });
    const blobData = await response.blob();
    const contentType = response.headers.get('content-type');
    return { blobData, contentType,certiFiled };
    
  } catch (error: any) {
    popSwal('error', "getPhotoWebp照片取得失敗", error.message || "請稍後再試")
    throw error
  }
}

// ---- API END

// file download
const getJwtBeforeRedirect = async (fileId) => {
  // 打开新链接
  const url = await mapFileDownload(fileUrl, fileId)
  window.open(url, '_blank');
};


const slides = ref([])
// 上傳文件-多檔
const handleOfficalFileMultiple = async(valFile , valId) => {
  if (form.uploadData[valFile] && form.uploadData[valFile].length>0) {
    const formData = new FormData();
    slides.value = []
    form.uploadData[valFile].forEach((file, index) => {
      if (file.type.startsWith('image/')) {
        slides.value.push({
          type: 'image',
          url: URL.createObjectURL(file),
          name: file.name,
          size: file.size,
        })
      } else {
        slides.value.push({
          type: 'file',
          name: file.name,
          size: file.size,
          url:file.name,
        })
      }
      formData.append('multiFiles', file);
    });
    await uploadFileMultiple(formData,valId)
  }

}

const clearFile = (val)=>{
  form.uploadData.certFiles = []
  form.uploadData.certFilesId=''
  slides.value.forEach(slide => {
    if (slide.type === 'image') {
      URL.revokeObjectURL(slide.url)
    }
  })
  slides.value = []
}

const uploadCert = async()=>{
  if(form.uploadData.certFiles.length>5 || certFilesToArray(form.uploadData.certFilesId).length>5){
    popSwal('error','檔案超過限制','只允許最多五個檔案')
    return 
  }
  if(!form.uploadData.certFilesId){
    popSwal('error','檔案未上傳成功','請重新選取檔案上傳')
    return
  }
  const { valid,errors } = await formRef.value.validate();
  if(valid){
    const response = await updateInvoice()
    addList.value.unshift(...response)
  }else{
    const errorsIds = errors.map(item => item.id)
    popSwal('error','新增憑證資料不完整',errorsIds)
    return 
  }
}

const getScheduleName = (scheduleId)=>{
  if(!scheduleId || !form.scheduleIdnItemList.scheduleList){
    return scheduleId??''
  }
  let name = form.scheduleIdnItemList.scheduleList.find(schedule=>schedule.scheduleNo===scheduleId)?.scheduleName ?? scheduleId
  if (isGold.value && name) {
    name = name.replace(/年度費用/g, '運動型保險')
  }
  return name
}

const matchAddList = (item)=>{
  return addList.value.some(addItem=>addItem.prikey===item.prikey)
}

const certFilesToArray = (data)=>{
  if(Array.isArray(data)){
    return data
  } else if (typeof data === 'string' && data.length > 0) {
    return data.split(',');
  } else {
    return [];
  }
}

const getReimbursementItemName = (reimbursement)=>{
  if(!reimbursement||reimbursement.length===0){
    return ''
  }
  if(reimbursement=='other'){
    return '其他'
  }
  if (!reimbursementItems.value) {
    return reimbursement;
  }
  return reimbursementItems.value.find(reimbursementItem=>reimbursementItem.value===reimbursement)?.label ?? reimbursement
}

const mappingScheduleItemList = async()=>{
  const scheduleItemList = await getScheduleItemList()
  let scheduleList = []
  let scheduleItem = {}
  scheduleItemList.forEach(schedule=>{
    let itemListData = []
    schedule.itemList.forEach(item=>{
      if (!itemListData.some(existingItem => existingItem.itemType === item.itemType)) {
        itemListData.push({
          itemType:item.itemType,
          itemName: getReimbursementItemName(item.itemType)
        })
      }
    })
    let title = schedule.expReqSchedule.scheduleTitle
    if (isGold.value && title) {
      title = title.replace(/年度費用/g, '運動型保險')
    }
    scheduleItem[schedule.expReqSchedule.scheduleId] = {
      scheduleName: title,
      itemList: itemListData
    }
    scheduleList.push({
      scheduleNo:schedule.expReqSchedule.scheduleId,
      scheduleName:title,
    })
  })
  return {scheduleItem,scheduleList}
}

const changeApplyNo = async()=>{
  form.uploadData.scheduleId = ''
  form.uploadData.itemId = ''
  if(form.applyNo){
    // const scheduleItemList = await getScheduleItemList(form.applyNo)
    form.scheduleIdnItemList = await mappingScheduleItemList()
    const response = await getInvoiceByApplyNo(form.applyNo)
  }else{
    form.reimbursementItemList.splice(0,form.reimbursementItemList.length)
  }
}

const deleteCertiItem = (item)=>{
  $swal({
    title: `刪除資料`,
    text: `檔案有${certFilesToArray(item.certFiles).length}筆${item.scheduleId?'-'+getScheduleName(item.scheduleId):''} ${item.itemId?'的'+getReimbursementItemName(item.itemId):''}`,
    icon: 'warning',
    showCancelButton: true,
    cancelButtonText: "取消",
    confirmButtonText: '我要刪除',
  }).then(async(result)=>{
    if(result.isConfirmed){
      const response = await deleteInvoice(item.prikey)
    }
  })
}

const openDialog = async(item) => {
  loading.value = true
  try {
    if (dialogData.value.certFiles !== `${item.certFiles}.webp`) {
      dialogData.value.certFiles = item.certFilesId
      const { blobData, contentType, certiFiled } = await getPhotoWebp(`${item.certFiles}.webp`)
      if(contentType.includes('webp')){
        console.log('contentType.includes(image)')
        if (!!blobData) {
          URL.revokeObjectURL(dialogData.value.photo)
          Object.assign(dialogData.value, 
            { 
              photo: URL.createObjectURL(blobData), 
              contentType, 
              certFiles:certiFiled 
            }
          )
          isDialogVisible.value = true
        }
      }else{
        if (!!blobData) {
          URL.revokeObjectURL(dialogData.value.photo)
          Object.assign(dialogData.value, 
            { 
              photo: '', 
              contentType, 
              certFiles:certiFiled 
            }
          )
          isDialogVisible.value = true
        }
      }
    }else{
      isDialogVisible.value = true
    }
  } catch (error) {
    console.error('Error in openDialog:', error)
  } finally {
    loading.value = false
  }
}

watch(filter.value,()=>{
  if(form.applyNo){
    getInvoiceByApplyNo(form.applyNo)
  }
})

</script>


